
















import { defineComponent } from "@vue/composition-api";
import { VaultCategory } from "@scrile/api-provider/dist/api/VaultsProvider";
import InfiniteScroll from "@/components/InfiniteScroll";
import VaultCategoryItem from "../VaultCategoryItem";

export default defineComponent({
  name: "VaultCategoryList",
  components: { VaultCategoryItem, InfiniteScroll },
  props: {
    items: { type: Array as () => VaultCategory[], default: () => [] },
    checkedCategoryId: { type: String },
    scroll: { type: Boolean },
  },
});
